import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByMonthByAuthorisingUserList from './components/month/RequestsByMonthListByAuthorisingUser';
import RequestsByWeekByAuthorisingUserList from './components/week/RequestsByWeekListByAuthorisingUser';

function RequestsByAuthorisingUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Requests by authorising user"
      MonthList={RequestsByMonthByAuthorisingUserList}
      WeekList={RequestsByWeekByAuthorisingUserList}
    />
  );
}

export default RequestsByAuthorisingUser;
